"use strict";

exports.__esModule = true;
exports.getWidgetColorProps = getWidgetColorProps;
/**
 * Get color related properties for a widget.
 */
function getWidgetColorProps(_ref) {
  var color = _ref.color,
    backgroundColor = _ref.backgroundColor,
    colorSource = _ref.colorSource,
    backgroundColorSource = _ref.backgroundColorSource;
  return {
    color: color,
    backgroundColor: backgroundColor,
    colorSource: colorSource,
    backgroundColorSource: backgroundColorSource
  };
}